import React from "react";
import NavBarButton from "../NavBarButton";
import { ModuleKey } from "../../constants/roleAccess";
import { useModuleAccess } from "../../hooks/useModuleAccess";

import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg";
import { ReactComponent as DevicesIcon } from "../../assets/icons/devices.svg";
import { ReactComponent as ProgramIcon } from "../../assets/icons/code.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as SupportIcon } from "../../assets/icons/contact_support.svg";
import { ReactComponent as DataIcon } from "../../assets/icons/collection.svg";
import { ReactComponent as MarketIcon } from "../../assets/icons/market.svg";
import { ReactComponent as RulerIcon } from "../../assets/icons/ruler.svg";
import { ReactComponent as HubIcon } from "../../assets/icons/hub.svg";
import { ReactComponent as MESIcon } from "../../assets/icons/workspaces.svg";
import { ReactComponent as OrganizationIcon } from "../../assets/icons/account_circle.svg";

type NavBarItem = {
  module: ModuleKey;
  name: string;
  icon: JSX.Element;
};

const PRIMARY_ITEMS: NavBarItem[] = [
  { module: "dashboard", name: "Dashboard", icon: <DashboardIcon /> },
  { module: "devices", name: "Devices", icon: <DevicesIcon /> },
  { module: "develop", name: "Develop", icon: <RulerIcon /> },
  { module: "data", name: "Data", icon: <HubIcon /> },
  { module: "mes", name: "MES", icon: <MESIcon /> },
  { module: "organization", name: "Organization", icon: <OrganizationIcon /> },
  // { module: "marketplace", name: "Marketplace", icon: <MarketIcon /> },
  { module: "settings", name: "Settings", icon: <SettingsIcon /> },
];

const SECONDARY_ITEMS: NavBarItem[] = [
  { module: "support", name: "Support", icon: <SupportIcon /> },
];

const NavBar = () => {
  const { canAccessModule } = useModuleAccess();

  const renderItems = (items: NavBarItem[]) =>
    items
      .filter((item) => canAccessModule(item.module))
      .map((item) => (
        <NavBarButton
          key={item.module}
          path={item.module}
          name={item.name}
          icon={item.icon}
        />
      ));

  return (
    <div className="nav-bar">
      <div className="nav-bar-primary">{renderItems(PRIMARY_ITEMS)}</div>
      <div className="nav-bar-secondary">{renderItems(SECONDARY_ITEMS)}</div>
    </div>
  );
};

export default NavBar;
